'use client';

import { c as _c } from "react/compiler-runtime";
import { CheckCircleSolid, InfoCircleSolid, Xmark, XmarkCircleSolid } from '@byway/icons';
import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { Button } from '~/components/Button';
import { visuallyHidden } from '~/components/Utilities';
import styles from './Notification.module.css';
import type { NotificationProps, Status, StatusProps } from './Notification.types';
const Notification = t0 => {
  const $ = _c(33);
  const {
    state,
    message,
    hideCloseButton,
    onClose,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const t = useTranslations("aria");
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      status: undefined,
      statusMessage: undefined
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [notification, setNotification] = useState(t2);
  let t3;
  let t4;
  if ($[1] !== message || $[2] !== state) {
    t3 = () => {
      setNotification({
        status: state,
        statusMessage: message
      });
    };
    t4 = [state, message];
    $[1] = message;
    $[2] = state;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== onClose) {
    t5 = () => {
      setNotification({
        status: undefined,
        statusMessage: undefined
      });
      onClose?.();
    };
    $[5] = onClose;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const handleClose = t5;
  let t10;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[7] !== handleClose || $[8] !== hideCloseButton || $[9] !== notification.status || $[10] !== notification.statusMessage || $[11] !== t || $[12] !== variant) {
    const statusClass = clsx({
      [styles.error]: notification.status === "error",
      [styles.info]: notification.status === "info",
      [styles.success]: notification.status === "success"
    });
    const variantClass = clsx({
      [styles.container]: true,
      [styles.maps]: variant === "maps"
    });
    let t11;
    if ($[18] !== t) {
      t11 = t("status_error");
      $[18] = t;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    let t12;
    if ($[20] !== t) {
      t12 = t("status_success");
      $[20] = t;
      $[21] = t12;
    } else {
      t12 = $[21];
    }
    let t13;
    if ($[22] !== t11 || $[23] !== t12) {
      t13 = {
        error: t11,
        success: t12
      };
      $[22] = t11;
      $[23] = t12;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    const statusLabel = t13;
    let t14;
    if ($[25] !== notification.status) {
      t14 = () => {
        switch (notification.status) {
          case "error":
            {
              return <XmarkCircleSolid decorative={true} size="scale" color="currentColor" dataTestId="icon-error" />;
            }
          case "info":
            {
              return <InfoCircleSolid decorative={true} size="scale" color="currentColor" dataTestId="icon-info" />;
            }
          case "success":
            {
              return <CheckCircleSolid decorative={true} size="scale" color="currentColor" dataTestId="icon-success" />;
            }
          default:
            {
              return null;
            }
        }
      };
      $[25] = notification.status;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    const Icon = t14;
    t6 = "Notification";
    t7 = "status";
    t8 = "polite";
    t9 = "true";
    t10 = notification.statusMessage && <div className={clsx(variantClass, statusClass)} data-test-id="Notification-content"><span className={clsx(styles.icon, statusClass)}>{Icon()}</span>{notification.status && statusLabel[notification.status] && <span className={visuallyHidden}>{statusLabel[notification.status]}</span>}{notification.statusMessage}{hideCloseButton !== true && <span className="ml-auto"><Button variant="icon" isTransparent={true} ariaLabel={t("close")} onPress={() => handleClose()}><Xmark decorative={true} size="large" /></Button></span>}</div>;
    $[7] = handleClose;
    $[8] = hideCloseButton;
    $[9] = notification.status;
    $[10] = notification.statusMessage;
    $[11] = t;
    $[12] = variant;
    $[13] = t10;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t10 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t6 || $[29] !== t7 || $[30] !== t8 || $[31] !== t9) {
    t11 = <div data-test-id={t6} role={t7} aria-live={t8} aria-atomic={t9}>{t10}</div>;
    $[27] = t10;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
};
export { Notification };